import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react'
import Modal, { ModalHeader, ModalTab } from '../../../../components/Modal';
import BankTransListModal from './BankTransListModal';
import ExpenseListModal from './ExpenseListModal';
import InvoiceListModal from './InvoiceListModal';

const CardRelatedModal = ({ open, setOpen, type, submit, data, permissions }) => {
  const [activeTab, setActiveTab] = useState(null);
  const [tabList, setTabList] = useState([]);

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      setActiveTab(permissions[0].code)
      setTabList(permissions.map((p) => ({
        label: p.name,
        value: p.code,
        action: setActiveTab
      })))

      if (!open)
      {
        setActiveTab(permissions[0].code)
      }
    }
  }, [permissions, open])

  const cancel = () => {
    setOpen(false)
  }

  return (
    <Modal isOpen={open} close={cancel} size="xx-lg">
      <div className="bank-trans-related-list-modal">
        <ModalHeader>관련항목 추가</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        {activeTab === 'FUND_BANK_HISTORY' && <BankTransListModal cardData={data} open={open} setOpen={setOpen} type={type} detailSubmit={submit} />}
        {activeTab === 'TRADE_INVOICE' && <InvoiceListModal cardData={data} open={open} setOpen={setOpen} type={type} detailSubmit={submit} />}
        {activeTab === 'EXPENSE' && <ExpenseListModal cardData={data} open={open} setOpen={setOpen} type={type} detailSubmit={submit} />}
      </div>
    </Modal>
  )
}

export default CardRelatedModal;